module.exports = __webpack_public_path__ + "img/visa.c7e8c462.svg";